export var isNullOrUndefinedOrEmpty = function(value) {
    return value === null || value === '' || typeof value === 'undefined';
};
